import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deleteExternalExamRegistrationOperation = async (
  groupId: number,
  examId: number,
  registrationId: number,
  setRegistrationId: (registrationId: number | null) => any,
  onSuccess: () => void,
) => {
  try {
    setRegistrationId(registrationId);

    const res = await appApi.deleteExternalExamRegistration(
      groupId,
      examId,
      registrationId,
    );

    if (res.data.ok) {
      toast.success('הסרת זכאות להרשמה בוצעה בהצלחה');
      onSuccess();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      toast.error('הסרת זכאות להרשמה נכשלה, נסה שוב בעוד מספר רגעים...');
    }

    setRegistrationId(null);
  } catch (e) {
    toast.error('הסרת זכאות להרשמה נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `deleteExternalExamRegistrationOperation failed for registrationId: ${registrationId} with error: ${e}`,
    );
    setRegistrationId(null);
  }
};
